import MoneyInput from './MoneyInput';

export default MoneyInput;
